import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { AppRoutes } from './app.routes';

import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipsModule } from 'primeng/chips';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ColorPickerModule } from 'primeng/colorpicker';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { InputMaskModule } from 'primeng/inputmask';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { MultiSelectModule } from 'primeng/multiselect';
import { PaginatorModule } from 'primeng/paginator';
import { PanelModule } from 'primeng/panel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { PasswordModule } from 'primeng/password';
import { PickListModule } from 'primeng/picklist';
import { ProgressBarModule } from 'primeng/progressbar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SlideMenuModule } from 'primeng/slidemenu';
import { SliderModule } from 'primeng/slider';
import { SpinnerModule } from 'primeng/spinner';
import { TabMenuModule } from 'primeng/tabmenu';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { ToastModule } from 'primeng/toast';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';
import { TreeTableModule } from 'primeng/treetable';
import { VirtualScrollerModule } from 'primeng/virtualscroller';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

import { AppComponent } from './app.component';
import { AppMainComponent } from './app.main.component';
import { AppNotfoundComponent } from './pages/app.notfound.component';
import { AppErrorComponent } from './pages/app.error.component';
import { AppAccessdeniedComponent } from './pages/app.accessdenied.component';
import { AppLoginComponent } from './pages/app.login.component';
import { AppMenuComponent, AppSubMenuComponent } from './app.menu.component';
import { AppBreadcrumbComponent } from './app.breadcrumb.component';
import { AppConfigComponent } from './app.config.component';
import { AppTopBarComponent } from './app.topbar.component';
import { AppFooterComponent } from './app.footer.component';
import { UserTableComponent } from './demo/view/usertable.component';
import { UserEditComponent } from './demo/view/useredit.component';
import { CompanyTableComponent } from './demo/view/company-table.component';
import { CompanyEditComponent } from './demo/view/company-edit.component';

import { ReportDefinitionTableComponent } from './demo/view/reportdefinition-table.component';
import { ReportDefinitionEditComponent } from './demo/view/reportdefinition-edit.component';
import { ReportDefinitionService} from './demo/service/reportdefinition.service';
import { LookupService } from './demo/service/lookup.service';

import { BreadcrumbService } from './breadcrumb.service';
import { MessageService } from 'primeng/api';

import {AuthGuardService} from './demo/service/authguardservice';
import { UserService} from './demo/service/user.service';
import { CompanyService} from './demo/service/company.service';

import { JwtModule } from '@auth0/angular-jwt';

import { SecuredImageComponent } from './demo/domain/secured-image.component';
import { SecuredReportImageComponent } from './demo/domain/secured-report-image.component';
import { TreeAccountsComponent } from './demo/view/tree-accounts.component';
import { AccountsTotalingPickerComponent } from './demo/view/accounts-totaling-picker.component';
import { DimensionTotalingPickerComponent } from './demo/view/dimension-totaling-picker.component';
import { FormulaPickerComponent } from './demo/view/formula-picker.component';
import { ReportCardComponent } from './demo/view/report-card.component';
import { DimensionPickerComponent } from './demo/view/dimension-picker.component';
import { UserRestrictedEditComponent } from './demo/view/user-restricted.edit.component';
import { TreeAccountsVirtualComponent } from './demo/view/tree-accounts-virtual.component';
import { TreeTableComponent } from './demo/view/tree-table.component';
import { ListTableComponent } from './demo/view/list-table.component';

import { ModalFilterPickerComponent } from './demo/view/modal-filter-picker.component';
import { ModalShowReportAccounts } from './demo/view/modal-show-report-accounts.component';
import { ModalShowLineAccounts } from './demo/view/modal-show-line-accounts.component';
import { IConfig } from 'ngx-mask';

import {AuthHeadersInterceptor} from './interceptors/auth-headers';
import { FilterPickerComponent } from './demo/view/filter-picker';
import { DimensionTotalingComponent } from './demo/view/dimension-totaling.component';
import { DimensionPickerTreeComponent } from './demo/view/dimension-picker-tree.component';
import { AllocationFactorsEditComponent } from './demo/view/allocation-factors-edit.component';
import { AllocationFactorsImportComponent } from './demo/view/allocation-factors-import.component';
import { AllocationDefinitionTableComponent } from './demo/view/allocation-definition-table.component';
import { AllocationDefinitionService } from './demo/service/allocationdefinition.service';
import { ModalAllocationItemPicker } from './demo/view/modal-allocation-item-picker.component';
import { ModalDimensionValuePicker } from './demo/view/modal-dimension-value-picker.component';
import { DynamicBackendConfigService } from './demo/service/dynamic-backend-config.service';
import { AppConfigService } from './demo/service/app-config.service';

import { ContextMenuService as GridContextMenuService, EditService, GridModule,  PageService as GridPageService, SortService as GridSortService, ToolbarService,FilterService,ResizeService as ResizeServiceGrid ,GroupService, AggregateService, ForeignKeyService} from '@syncfusion/ej2-angular-grids';
import { TabModule  } from '@syncfusion/ej2-angular-navigations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { BrowserModule } from '@angular/platform-browser';
//import { DropDownListModule,MultiSelectModule as SyncfusionMultiSelectModule  } from '@syncfusion/ej2-angular-dropdowns';
import {  ItemModel, MenuEventArgs,DropDownButtonModule } from '@syncfusion/ej2-angular-splitbuttons';
import {
  TreeGridModule,
  RowDDService,
  PageService as TreePageService,
  ContextMenuService  as TreeContextMenuService,
  SortService as TreeSortService,
  ResizeService as ResizeServiceTree,
   FilterService as TreeFilterService 
} from '@syncfusion/ej2-angular-treegrid'


export function tokenGetter() {
    return localStorage.getItem('jwt');
  }

export const options: Partial<IConfig> | (() => Partial<IConfig>) = {};

// registerAllModules();
@NgModule({
    imports: [
        AppRoutes,
        HttpClientModule,
        BrowserAnimationsModule,
        AccordionModule,
        AutoCompleteModule,
        BreadcrumbModule,
        ButtonModule,
        CardModule,
        CheckboxModule,
        ChipsModule,
        ConfirmDialogModule,
        ColorPickerModule,
        ContextMenuModule,
        DialogModule,
        DropdownModule,
        FileUploadModule,
        InputMaskModule,
        InputSwitchModule,
        InputTextModule,
        InputTextareaModule,
        MenuModule,
        MenubarModule,
        MultiSelectModule,
        PaginatorModule,
        PanelModule,
        PanelMenuModule,
        PasswordModule,
        PickListModule,
        ProgressBarModule,
        RadioButtonModule,
        RatingModule,
        SelectButtonModule,
        SlideMenuModule,
        SliderModule,
        SpinnerModule,
        TableModule,
        TabMenuModule,
        TabViewModule,
        TieredMenuModule,
        ToastModule,
        ToggleButtonModule,
        ToolbarModule,
        TooltipModule,
        TreeModule,
        TreeTableModule,
        VirtualScrollerModule,
        ProgressSpinnerModule,
        GridModule,
        TabModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        //DropDownListModule,
        //SyncfusionMultiSelectModule,
        TreeGridModule,
        DropDownButtonModule,
        // HotTableModule,
        //NgxMaskDirective.forRoot(options),
        JwtModule.forRoot({
            config: {
              tokenGetter: tokenGetter,
              allowedDomains: ['localhost:44336', 'localhost:5001', 'localhost:5095', 'localhost:5078','104.248.130.160:5000', 'h2854071.stratoserver.net:4200', 'matrica.hr:4200','192.168.12.219:5078','192.168.12.219:5095'],
              disallowedRoutes: ['localhost:44336/api/auth/create_token', '104.248.130.160:5000/api/auth/create_token', 'h2854071.stratoserver.net:4200/api/auth/create_token', 'matrica.hr:4200/api/auth/create_token']
            }
          })
    ],
    declarations: [
        AppComponent,
        AppMainComponent,
        AppMenuComponent,
        AppSubMenuComponent,
        AppBreadcrumbComponent,
        AppConfigComponent,
        AppTopBarComponent,
        AppFooterComponent,
        AppNotfoundComponent,
        AppErrorComponent,
        AppAccessdeniedComponent,
        AppLoginComponent,
        UserTableComponent,
        UserEditComponent,
        CompanyTableComponent,
        CompanyEditComponent,
        ReportDefinitionTableComponent,
        ReportDefinitionEditComponent,
        SecuredImageComponent,
        SecuredReportImageComponent,
        TreeAccountsComponent,
        TreeAccountsVirtualComponent,
        TreeTableComponent,
        AccountsTotalingPickerComponent,
        FormulaPickerComponent,
        ReportCardComponent,
        DimensionPickerComponent,
        DimensionTotalingPickerComponent,
        UserRestrictedEditComponent,
        FilterPickerComponent,
        ModalFilterPickerComponent,
        ModalShowReportAccounts,
        ModalShowLineAccounts,
        ListTableComponent,
        DimensionTotalingComponent,
        DimensionPickerTreeComponent,
        AllocationFactorsEditComponent,
        AllocationFactorsImportComponent,
        AllocationDefinitionTableComponent,
        ModalAllocationItemPicker,
        ModalDimensionValuePicker
    ],
    providers: [
        {provide: LocationStrategy, useClass: HashLocationStrategy},
        { provide: HTTP_INTERCEPTORS, useClass: AuthHeadersInterceptor, multi: true },
        {
          provide: APP_INITIALIZER,
          multi: true,
          deps: [AppConfigService],
          useFactory: (appConfigService: AppConfigService) => {
            return () => {
              return appConfigService.loadAppConfig();
            };
          }
        },
        BreadcrumbService,
        DynamicBackendConfigService,
        MessageService,   AuthGuardService, UserService, CompanyService, ReportDefinitionService,
        LookupService, AllocationDefinitionService, GridContextMenuService, TreeContextMenuService, RowDDService,
        GridPageService, TreePageService, ToolbarService,TreeFilterService, EditService,FilterService, ResizeServiceGrid, ResizeServiceTree,GroupService,AggregateService,ForeignKeyService,GridSortService,TreeSortService,DropDownButtonModule],
    bootstrap: [AppComponent]
})
export class AppModule { }
